// extracted by mini-css-extract-plugin
export default {"formSection":"formSection---M_X6v","formSectionHeading":"formSectionHeading---HVKsT"};